import React, { Component } from 'react';
import ReconciliationController from './reconciliation.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Card } from '../common';
import Page from '../common/page/Page';
import { SCOPES } from '../../constants/scopes.constants';
import ReconciliationTable from './elements/ReconciliationTable';
import ReconciliationTableActions from './elements/ReconciliationTableActions';

class Reconciliation extends Inherit(ReconciliationController, Component) {
    state = { loading: true, reconciliation: [], rows: [] };

    render() {
        const { loading, reconciliation, rows } = this.state;
        return (
            <Page
                isLoading={loading}
                scope={SCOPES.DASHBOARD_VIEW}
                title={{ text: 'Reconciliation' }}
                notificationContextHolder={this.props.notificationContextHolder}
            >
                <ReconciliationTableActions setRows={this.setRows.bind(this)} reconciliation={reconciliation} rows={rows} />
                <Card>
                    <ReconciliationTable rows={rows} loading={loading} />
                </Card>
            </Page>
        );
    }
}

export default withHooks(Reconciliation);
